
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/severalbrands/[category]",
      function () {
        return require("private-next-pages/severalbrands/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/severalbrands/[category]"])
      });
    }
  